import React from "react";
import "./index.scss";
import {oneOfType, string, object, func, bool} from "prop-types";

const TextArea = (props) => {
    const {placeholder, value, onChange, disabled} = props;
    return <div className={`text-area ${!!disabled ? 'disabled' : ''}`}>
        {(placeholder && !value) && <span className="placeholder">{placeholder}</span>}
        <textarea disabled={!!disabled} onChange={(event) => onChange(event.target.value)} value={value} />
    </div>
};
TextArea.propTypes = {
    placeholder: oneOfType([string, object]),
    value: string.isRequired,
    onChange: func.isRequired,
    disabled: bool
};
export default TextArea;